<template>
  <Header ></Header>
  <router-view/>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import {useAppStore} from "@/stores/app";
import {mapState} from "pinia";
import {useActivityStore} from "@/stores/activityStore";
import {useApiStore} from "@/stores/api";
import {useUserStore} from "@/stores/users";

const preloader = document.querySelector('.preloader');
export default {
  name: 'HomeView',

  components: {
    Header
  },
  setup() {
    const activityStore = useActivityStore();
    const apiStore = useApiStore();
    const userStore = useUserStore();
    return {
      activityStore,
      apiStore,
      userStore
    };
  },
  data() {
    return {
      activityInterval: null,
      scrollTimeout: null
    }
  },
  computed: {
    ...mapState(useAppStore, ['loading']),
  },
  watch: {
    loading: {
      handler(val) {
        preloader.style.display = val ? '' : 'none';
      },
      immediate: true,
    },
  },
  mounted() {
    this.startActivityTracking();
    this.setupGlobalScrollTracking();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeUnmount() {
    if (this.activityInterval) {
      clearInterval(this.activityInterval);
      this.activityInterval = null;
    }

    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    window.removeEventListener('scroll', this.throttledScrollUpdate);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

    this.sendActivity();
  },
  methods: {
    stopActivityTracking() {
      if (this.activityInterval) {
        clearInterval(this.activityInterval);
        this.activityInterval = null;
      }
    },

    startActivityTracking() {
      this.stopActivityTracking();
      this.activityInterval = setInterval(() => {
        this.sendActivity();
      }, 10000);
    },

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopActivityTracking();
        this.sendActivity();
      } else {
        this.startActivityTracking();
      }
    },
    
    async sendActivity() {
      try {
        const currentRouteName = this.$route?.name ?? null;
        const interactionData = this.activityStore.getInteractionData(currentRouteName);
        if (!interactionData.interactions?.length) return;
        await this.apiStore.sendUserInteraction(interactionData);
      } catch (error) {
        // Игнорируем ошибки отправки активности
      }
    },
    
    // Глобальное отслеживание скролла
    setupGlobalScrollTracking() {
      // Throttle для оптимизации
      this.throttledScrollUpdate = () => {
        if (this.scrollTimeout) return;
        this.scrollTimeout = setTimeout(() => {
          this.activityStore.updateGlobalScrollDepth();
          this.scrollTimeout = null;
        }, 100);
      };
      
      // Отслеживание скролла
      window.addEventListener('scroll', this.throttledScrollUpdate, { passive: true });
      
      // Первоначальный расчет
      this.$nextTick(() => {
        this.activityStore.updateGlobalScrollDepth();
      });
    }
  }
}
</script>

<style lang="less">
@import '@/assets/less/common.less';
</style>
